// @flow
import {all} from 'redux-saga/effects';
import authSaga from '../modules/auth/redux/saga';
import layoutSaga from '../modules/ui/layouts/redux/layout/saga';
import appMenuSaga from '../modules/ui/components/AppMenu/redux/saga';
import {group, user} from '../modules/users/redux';

import {sagas as templateSagaCRUD, sagas as templateSaga} from '../modules/templates/redux';
import {
    dependentDocument,
    documentDetailSaga,
    linkedDocument,
    sagas as documentSagaCRUD
} from '../modules/documents/redux';
import {sagas as scanSagaCRUD} from '../modules/scan/redux';
import scanSaga from '../modules/scan/redux/saga'
import {masterDataSaga, sagas as masterDataSagaCRUD} from '../modules/settings/master-data/redux'
import notificationSaga from '../modules/ui/components/NotificationDropdown/redux/saga';

import {apiKey, billing, subscription} from '../modules/settings/redux';
import settingCoreSaga from '../modules/settings/redux/saga';
import {folder} from '../modules/users/redux/index';
import templateCoreSaga from '../modules/templates/redux/saga';
import {
    documentAuditTrailReport,
    invoiceReport,
    masterViewReport,
    statisticReport,
    userAuditTrailReport,
    userManagementReport,
    massUpdate
} from '../modules/report/redux';
import {dashboardSaga} from '../modules/dashboard/redux';
import reportCoreSaga from '../modules/report/redux/saga';

// setting big module
const apiKeySaga = apiKey.sagas;
const subscriptionSaga = subscription.sagas;
const billingSaga = billing.sagas;

// user big module
const userSaga = user.sagas;
const userCoreSaga = user.userCoreSaga;

// group big module
const groupSaga = group.sagas;
const groupCoreSaga = group.groupCoreSaga;

// reports sagas
const statisticReportSaga = statisticReport.sagas;
const invoiceReportSaga = invoiceReport.sagas;
const userManagementReportSaga = userManagementReport.sagas;
const userAuditTrailReportSaga = userAuditTrailReport.sagas;
const masterViewReportSaga = masterViewReport.sagas;
const documentAuditTrailReportSaga = documentAuditTrailReport.sagas;

// document sagas
const dependentDocumentSaga = dependentDocument.sagas;
const linkedDocumentSaga = linkedDocument.sagas;
const massUpdateSaga = massUpdate.sagas;

export default function* rootSaga(getState: any): any {
    yield all([
        authSaga(),
        layoutSaga(),
        appMenuSaga(),
        apiKeySaga(),
        userSaga(),
        userCoreSaga(),
        groupSaga(),
        groupCoreSaga(),
        templateSagaCRUD(),
        subscriptionSaga(),
        billingSaga(),
        templateSaga(),
        templateCoreSaga(),
        documentDetailSaga(),
        documentSagaCRUD(),
        dependentDocumentSaga(),
        linkedDocumentSaga(),
        scanSaga(),
        scanSagaCRUD(),
        notificationSaga(),
        folder.sagas(),
        masterDataSagaCRUD(),
        masterDataSaga(),
        reportCoreSaga(),
        statisticReportSaga(),
        invoiceReportSaga(),
        userManagementReportSaga(),
        userAuditTrailReportSaga(),
        masterViewReportSaga(),
        documentAuditTrailReportSaga(),
        dashboardSaga(),
        massUpdateSaga(),
        settingCoreSaga()
    ]);
}
